import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const ProductImage: React.FC<ISvgAtomProps> = ({ width = 170, height = 170 }) => {
  return (
    <svg className="product-image" x={0} y={0} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <rect x={0} y={0} width={width} height={height} rx={4} fill="#fff" stroke="#d6d6d6" />
      <g transform={`translate(${width / 2 - 7}, ${height / 2 - 8}) scale(0.7)`}>
        <path
          fill="#C8D4DD"
          d="M18 0a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H0a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h18zm-5.726 11.083l-4.584 6.875-3.273-4.583-4.584 6.875h18.334l-5.893-9.167z"
        />
      </g>
    </svg>
  );
};

export default ProductImage;
